module.exports = __webpack_public_path__ + "static/media/PCI-coy-2019-living-coral-16-1546-logo.94bb2f64.jpg";